"use client"

import { CURATED_PRODUCTS, type HeroProductView } from "./curated-products"

export type { HeroProductView }

/**
 * /start showcase products. Returns the hand-curated, self-hosted static set (see
 * `curated-products.ts`) — no network fetch, so the fan is always populated and never flashes a
 * skeleton or empty state (donista's live product catalog is transient and can be empty). Kept as
 * a hook returning `{ products, isLoading }` so `ProductsStack` (product-range.tsx) is unchanged.
 */
export function useHeroProducts(): { products: HeroProductView[]; isLoading: boolean } {
  return { products: CURATED_PRODUCTS, isLoading: false }
}
